module.exports = __webpack_public_path__ + "static/tchazzar-09b0186d7293d1d42eac8aabf834a93d.webp";